module.exports = __webpack_public_path__ + "img/cloth_g1_item_14.81be9f40.svg";